import React from 'react';

import styled from '../styled-components';

export default ({ children }: { children: React.ReactNode }) => {
    return (
        <Wrapper>
            {children}
        </Wrapper>

    )
};

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1;
  min-height: 100%;
  width: 100%;
`;
